<template>
  <v-container>
    <v-row justify="center">
      <ViewHeader :title="viewTitle" />
      <v-col cols="12">
        <v-card class="pa-4 competition__card">
          <template v-if="!businessAddresses.length > 0">
            <div class="d-flex align-center" style="min-height: 700px;">
              <v-row justify="center" align-content="center" class="no-data">
                <v-col sm="6" class="text-center">
                  <h3 class="mb-3">
                    {{ $t("message.common.addOwnBusinessAddress") }}
                  </h3>
                  <p>
                    {{
                      $t("message.visibility.summary.noBusinessAddressesInfo")
                    }}
                  </p>
                  <div class="d-flex flex-column mt-8">
                    <ui-button
                      icon="icon-google"
                      color="primary"
                      class="mb-2 mx-auto"
                      style="max-width: 250px; width: 100%;"
                      :to="{ name: 'profile-gmb-accounts' }"
                    >
                      {{ $t("message.common.importFacilities") }}
                    </ui-button>

                    <span class="mb-2">{{ $t("message.common.or") }}</span>
                    <ui-button
                      icon="icon-plus"
                      color="primary"
                      class="mx-auto"
                      style="max-width: 250px; width: 100%;"
                      :to="{ name: 'business-addresses' }"
                    >
                      {{ $t("message.common.addBusinessAddress") }}
                    </ui-button>
                  </div>
                </v-col>
              </v-row>
            </div>
          </template>
          <template v-else>
            <v-row>
              <v-col cols="12" lg="4" class="pa-3">
                <v-card class="pa-4" outlined>
                  <v-row>
                    <v-col cols="12">
                      <v-select
                        v-model="selectedBusinessAddress"
                        return-object
                        :label="
                          $t(
                            'message.competition.businessAddresses.label.yourBusinessAddress'
                          )
                        "
                        item-text="name"
                        item-value="place_id"
                        :items="filteredBusinessAddresses"
                        hide-details
                        @input="
                          fetchCompetitionForSelectedBusinessAddress(
                            selectedBusinessAddress.id
                          )
                        "
                      >
                        <template v-slot:prepend-item>
                          <v-list-item>
                            <v-list-item-content>
                              <v-text-field
                                hide-details
                                prepend-icon="icon-search"
                                :placeholder="$t('message.common.findFacility')"
                                full-width
                                v-model="search"
                                single-line
                              >
                              </v-text-field>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template #selection="{item}">
                          <v-list-item-content style="flex-basis: 100%;">
                            <v-list-item-title
                              v-html="item.name || item.url"
                            ></v-list-item-title>
                            <v-list-item-subtitle
                              v-html="item.formatted_address"
                            ></v-list-item-subtitle>
                          </v-list-item-content>
                        </template>
                        <template #item="{item}">
                          <template v-if="typeof item !== 'object'">
                            <v-list-item-content
                              v-text="item"
                            ></v-list-item-content>
                          </template>
                          <template v-else>
                            <v-list-item-content>
                              <v-list-item-title
                                v-html="item.name || item.url"
                              ></v-list-item-title>
                              <v-list-item-subtitle
                                v-html="item.formatted_address"
                              ></v-list-item-subtitle>
                            </v-list-item-content>
                          </template>
                        </template>
                      </v-select>
                    </v-col>

                    <v-col cols="12">
                      <v-text-field
                        :value="radius"
                        :label="$t('message.common.range')"
                        hide-details
                        type="number"
                        suffix="km"
                        class="radius-input"
                        @change="onRadiusChange"
                      ></v-text-field>
                    </v-col>
                    <v-col cols="12">
                      <v-autocomplete
                        name="mapPlaces"
                        :search-input.sync="autocompleteSearch"
                        :loading="loadingAutocomplete"
                        :items="autocompleteSuggestions"
                        class="py-0 my-0"
                        v-model="autocompleteSelected"
                        :label="
                          $t(
                            'message.competition.businessAddresses.label.addCompetitionBusinessAddress'
                          )
                        "
                        return-object
                        no-filter
                        item-text="description"
                        autocomplete="off"
                      >
                        <template #no-data>
                          <v-list-item>
                            <v-list-item-content>
                              <span>
                                {{
                                  $t("message.wizard.addNameAndchooseFromList")
                                }}
                              </span>
                            </v-list-item-content>
                          </v-list-item>
                        </template>
                        <template #append-item>
                          <div class="d-flex justify-end mr-2">
                            <img
                              src="@/static/powered_by_google_on_white.png"
                              alt="powered by Google"
                            />
                          </div>
                        </template>
                      </v-autocomplete>
                    </v-col>
                    <v-col cols="12" align-self="center">
                      <ui-button
                        color="primary"
                        block
                        @click="addCompetitionBusinessAddressToList"
                        :loading="inputLoading"
                      >
                        {{ $t("message.common.add") }}
                      </ui-button>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <h3 class="list-title">
                        {{ $t("message.common.competitiveBusinessAddresses") }}
                      </h3>
                      <v-list
                        v-if="competitionBusinessAddresses.length > 0"
                        two-line
                        class="wizard__list overflow-y-auto"
                        height="406px"
                      >
                        <template
                          v-for="(item, index) in competitionBusinessAddresses"
                        >
                          <v-list-item
                            :key="item.id"
                            :style="
                              !((index + 2) % 2)
                                ? 'background:' + listItemGrayColor
                                : ''
                            "
                          >
                            <v-tooltip right :max-width="tooltipMaxWidth">
                              <template #activator="{ on }">
                                <div class="marker__number">
                                  {{ item.coords.number }}
                                </div>
                                <v-list-item-content v-on="on">
                                  <v-list-item-title>
                                    <h5>{{ item.name }}</h5>
                                  </v-list-item-title>
                                  <v-list-item-subtitle>
                                    {{ item.formatted_address }}
                                  </v-list-item-subtitle>
                                </v-list-item-content>
                              </template>
                              <v-list-item-title>
                                <span>{{ item.name }}</span>
                              </v-list-item-title>
                              <v-list-item-subtitle>
                                {{ item.formatted_address }}
                              </v-list-item-subtitle>
                            </v-tooltip>
                            <v-menu left>
                              <template #activator="{ on }">
                                <ui-button
                                  icon="more_horiz"
                                  v-on="on"
                                ></ui-button>
                              </template>
                              <v-list>
                                <v-list-item>
                                  <v-btn
                                    color="error"
                                    text
                                    @click="deleteFromList(item)"
                                  >
                                    {{ $t("message.common.delete") }}
                                  </v-btn>
                                </v-list-item>
                              </v-list>
                            </v-menu>
                          </v-list-item>
                        </template>
                      </v-list>
                      <div v-else class="empty-list">
                        {{ $t("message.competition.businessAddresses.noData") }}
                      </div>
                      <SectionLoader :status="loadingKeywordList" />
                    </v-col>
                  </v-row>
                </v-card>
              </v-col>
              <v-col cols="12" lg="8" order="2" order-sm="1" class="pa-3">
                <v-card class="pa-4" outlined>
                  <!-- TODO: Change map animation on center -->
                  <Map
                    :coords="coords"
                    :center="center"
                    v-if="center"
                    :defaultStyles="`min-height: ${mapHeight}px; height: 100%;`"
                  >
                    <template v-slot:marker v-if="coords.length > 0">
                      <MapMarker
                        v-for="{ icon, id, marker } in coords"
                        :key="id"
                        :icon="icon"
                        :markerType="marker"
                      />
                      <template v-if="competitionBusinessAddresses.length > 0">
                        <MapMarker
                          v-for="{ coords } in competitionBusinessAddresses"
                          :key="coords.id"
                          :icon="coords.icon"
                          :markerType="coords.marker"
                          :number="coords.number"
                        />
                      </template>
                    </template>
                  </Map>
                </v-card>
              </v-col>
            </v-row>
            <v-row no-gutters>
              <v-col cols="12">
                <div class="d-flex">
                  <h4 class="my-2">{{ $t("message.common.suggested") }}</h4>
                  <v-tooltip bottom :max-width="tooltipMaxWidth">
                    <template v-slot:activator="{ on }">
                      <v-icon small color="primary" v-on="on" class="ml-1">
                        mdi-information-outline
                      </v-icon>
                    </template>
                    <span>{{
                      $t(
                        "message.competition.businessAddresses.suggestedTooltip"
                      )
                    }}</span>
                  </v-tooltip>
                </div>
              </v-col>
            </v-row>
            <v-footer min-height="80px" ref="footer">
              <template
                v-if="!suggestedCompetitionBusinessAddresses.length > 0"
              >
                <div class="d-flex justify-center align-center no-suggested">
                  <h5>
                    {{
                      $t("message.competition.businessAddresses.noSuggested")
                    }}
                  </h5>
                </div>
              </template>
              <template v-else>
                <v-chip
                  large
                  v-for="competition in suggestedCompetitionBusinessAddresses"
                  outlined
                  :key="competition.id"
                  class="ma-1 chip"
                  style="background: white !important;"
                  @click="addSuggestedToList(competition)"
                >
                  <div class="d-flex flex-column ma-4">
                    <h5>{{ competition.name }}</h5>
                    <span> {{ competition.formatted_address }}</span>
                  </div>
                </v-chip>
              </template>
              <SectionLoader :status="loadingSuggested" />
            </v-footer>
          </template>
          <SectionLoader :status="loading" :opacity="1" />
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SectionLoader from "@/components/Loader/SectionLoader.vue";
import Map from "@/components/ui/Map/Map.vue";
import MapMarker from "@/components/ui/Map/Marker.vue";
import ViewHeader from "@/components/ui/ViewHeader.vue";

import companyService from "@/services/company";
import competitionService from "@/services/competition";
import businessAddressesService from "@/services/businessAddresses";

import serviceHandler from "@/helpers/handlers/service";
import { GTM_EVENT_NAME } from "@/enums/gtm-events";

import { primary, numbered } from "@/config/marker.js";

import { debounce } from "@/helpers/helpers";

import { mapState } from "vuex";

import cuid from "cuid";

const MAXIMUM_RADIUS = 50;

export default {
  name: "CompetitionBusinessAddresses",
  components: {
    SectionLoader,
    Map,
    MapMarker,
    ViewHeader
  },

  data() {
    return {
      radius: 15,
      search: "",
      viewTitle: this.$t("message.competition.businessAddresses.title"),
      markerType: { primary, numbered },
      settings: {
        maxScrollbarLength: 160
      },
      listItemGrayColor: "#fcfcfc",
      mapHeight: 652,
      coords: [],
      businessAddresses: [],
      selectedBusinessAddress: {},
      competitionBusinessAddresses: [],
      loading: false,
      loadingKeywordList: false,
      loadingSuggested: false,
      loadingAutocomplete: false,
      inputLoading: false,
      autocompleteSelected: null,
      autocompleteSearch: null,
      autocompleteSuggestions: [],
      selectedCompetitionBusinessAddress: null,
      suggestedCompetitionBusinessAddresses: [],
      tooltipMaxWidth: 500
    };
  },

  computed: {
    ...mapState({
      companyId: state => state.company.id
    }),
    calculatedRadiusToKilometers() {
      return this.radius * 1000;
    },
    center() {
      if (
        this.selectedBusinessAddress !== undefined &&
        this.selectedBusinessAddress !== null
      ) {
        return {
          icon: this.selectedBusinessAddress.geo_coords,
          id: this.selectedBusinessAddress.place_id
        };
      }
      return { icon: [52.2200567, 19.2701527], id: cuid() };
    },

    footerHeight() {
      return this.$refs.footer.height;
    },

    filteredBusinessAddresses() {
      return this.businessAddresses.filter(item => {
        return (
          item.name.toLowerCase().match(this.search) ||
          item.formatted_address.toLowerCase().match(this.search)
        );
      });
    }
  },

  async created() {
    this.loading = true;
    await this.fetchBusinessAddresses();
    const prevSelectedId =
      this.$route.query.itemId && parseInt(this.$route.query.itemId);
    if (this.businessAddresses.length > 0) {
      await this.selectBusinessAddress(prevSelectedId);
      await this.fetchCompetitionBusinessAddresses();
      await this.fetchSuggestedCompetitionBusinessAddresses();
    }
    this.loading = false;
  },

  watch: {
    autocompleteSearch(value) {
      const CHAR_LENGTH = 2;

      if (value && value.length >= CHAR_LENGTH) {
        this.sendSearch(value);
      }
    }
  },

  methods: {
    onRadiusChange(radius) {
      if (+radius > MAXIMUM_RADIUS) {
        this.radius = MAXIMUM_RADIUS;
        return;
      } else if (+radius <= 0) {
        this.radius = 1;
        return;
      }
      this.radius = radius;
      this.autocompleteSuggestions = [];
    },
    async getCoords() {
      this.coords = [
        {
          icon: this.selectedBusinessAddress.geo_coords,
          id: this.selectedBusinessAddress.place_id,
          marker: this.markerType.primary
        }
      ];
    },

    async fetchBusinessAddresses() {
      const data = await serviceHandler(
        businessAddressesService.getBusinessAddressesData()
      );

      if (data.length > 0) {
        this.businessAddresses = data;
      }
    },

    selectBusinessAddress(id) {
      if (!id) {
        this.selectedBusinessAddress = this.businessAddresses[0];

        this.getCoords();
        return;
      }

      this.selectedBusinessAddress = this.businessAddresses.find(
        businessAddress => businessAddress.id === id
      );

      this.getCoords();
    },

    async fetchCompetitionBusinessAddresses() {
      const data = await serviceHandler(
        businessAddressesService.getCompetitionBusinessAddresses(
          this.selectedBusinessAddress.id
        )
      );

      const dataWithCoords = data.map((item, index) => {
        return {
          ...item,
          coords: {
            icon: item.geo_coords,
            id: item.place_id,
            marker: this.markerType.numbered,
            number: index + 1
          }
        };
      });

      this.competitionBusinessAddresses = dataWithCoords;
    },

    sendSearch: debounce(async function() {
      this.loadingAutocomplete = true;
      const params = {
        radius: this.calculatedRadiusToKilometers,
        lat: this.selectedBusinessAddress.geo_coords[0],
        lng: this.selectedBusinessAddress.geo_coords[1]
      };
      const data = await serviceHandler(
        companyService.getAutocompleteList(this.autocompleteSearch, params)
      );

      this.autocompleteSuggestions = data;
      this.loadingAutocomplete = false;
    }, 500),

    async addCompetitionBusinessAddressToList() {
      const isOnList = this.competitionBusinessAddresses.find(
        businessAddress =>
          businessAddress.place_id === this.autocompleteSelected.place_id
      );

      if (this.autocompleteSelected && !isOnList) {
        this.loadingSuggested = true;
        this.loadingKeywordList = true;

        const data = await serviceHandler(
          companyService.getBusinessAddressData(
            this.autocompleteSelected.place_id
          )
        );

        const addedLocationPlaceId = this.autocompleteSelected.place_id;

        await this.add(data);
        this.autocompleteSelected = null;
        await this.fetchCompetitionBusinessAddresses();
        await this.fetchSuggestedCompetitionBusinessAddresses();

        const addedLocation = this.competitionBusinessAddresses.find(
          location => location.place_id === addedLocationPlaceId
        );

        this.$gtm.trackCustomEvent({
          event: GTM_EVENT_NAME.COMPETITION_LOCATION_ADD,
          own_location_id: addedLocation ? addedLocation.id : null,
          input_type: "manual",
          competition_location_name: addedLocation ? addedLocation.name : null,
          competition_location_address: addedLocation
            ? addedLocation.formatted_address
            : null
        });
      }
      this.loadingSuggested = false;
      this.loadingKeywordList = false;
    },

    async add(businessAddress) {
      await serviceHandler(
        businessAddressesService.postCompetitionBusinessAddress(
          this.selectedBusinessAddress.id,
          [businessAddress]
        )
      );
    },

    async deleteFromList(competitionBusinessAddress) {
      this.selectedCompetitionBusinessAddress = null;

      this.loadingSuggested = true;
      this.loadingKeywordList = true;

      await serviceHandler(
        businessAddressesService.deleteCompetitionBusinessAddress(
          this.selectedBusinessAddress.id,
          competitionBusinessAddress.id
        )
      );

      await this.fetchCompetitionBusinessAddresses();
      await this.fetchSuggestedCompetitionBusinessAddresses();

      this.loadingSuggested = false;
      this.loadingKeywordList = false;
    },

    async fetchSuggestedCompetitionBusinessAddresses() {
      const data = await serviceHandler(
        businessAddressesService.getSuggestedBusinessAddresses(
          this.selectedBusinessAddress.id
        )
      );

      this.suggestedCompetitionBusinessAddresses = data;
    },

    async addSuggestedToList(val) {
      this.loadingSuggested = true;
      this.loadingKeywordList = true;

      await serviceHandler(
        businessAddressesService.postSuggestedBusinessAddress(
          this.selectedBusinessAddress.id,
          [val]
        )
      );

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.COMPETITION_LOCATION_ADD,
        own_location_id: val ? val.id : null,
        input_type: "suggested",
        competition_location_name: val ? val.name : null,
        competition_location_address: val ? val.formatted_address : null
      });

      await this.fetchCompetitionBusinessAddresses();
      await this.fetchSuggestedCompetitionBusinessAddresses();
      this.loadingSuggested = false;
      this.loadingKeywordList = false;
    },

    async fetchCompetitionForSelectedBusinessAddress(id) {
      this.loadingSuggested = true;

      this.$gtm.trackCustomEvent({
        event: GTM_EVENT_NAME.LOCATION_PICKER_SELECT,
        location_id: id
      });

      this.loadingKeywordList = true;

      await this.selectBusinessAddress(id);
      await this.fetchCompetitionBusinessAddresses();
      await this.fetchSuggestedCompetitionBusinessAddresses();

      this.loadingSuggested = false;
      this.loadingKeywordList = false;
    }
  }
};
</script>

<style lang="scss" scoped>
.empty-list {
  @include font-size(13px);
  margin-bottom: $spacing * 2;
}
.marker__number {
  height: 20px;
  width: 20px;
  border: 1px solid $orange;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  color: $orange;
  margin-right: 13px;
}

.no-suggested {
  color: $gray-light;
  width: 100%;
}

.chip {
  background: white !important;
}

.view__header {
  color: $grey-darker;
  font-weight: 600;
}

.summary__header {
  color: $grey-darker;
  font-weight: 600;
}

.select-title {
  font-weight: 600;
}

.no-data {
  height: 100%;
}
.list-title {
  @include font-size(16px);
}
.radius-input {
  ::v-deep input::-webkit-outer-spin-button,
  ::v-deep input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  ::v-deep input[type="number"] {
    -moz-appearance: textfield; /* Firefox */
  }
}
</style>
